export default "__VITE_ASSET__ByL$Jfq1__"